/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/
import { formatDate } from '../../application';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';
import { PreventativeMaintenanceTab } from './pm';

export class PMHistoryWindow extends VisionWindow {
    historyGrid!: dhtmlXGridObject;

    tab: PreventativeMaintenanceTab;
    assetId!: string;

    constructor(manager: VisionWindowManager, tab: PreventativeMaintenanceTab) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.45;
        super(manager, {
            id: 'history_pm_window',
            title: 'PM History',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });
        this.window.setText('History');

        this.tab = tab;
        this.buildUI();
        this.setupEvents();
    }

    public setAsset(id: string) {
        this.assetId = id;

        this.tab.service.fetchHistory(id).then((response) => {
            if (response.parsedBody) {
                response.parsedBody.forEach((item) => {
                    const rowdata = [];
                    rowdata.push(formatDate(item.completedDate));
                    rowdata.push(item.pmname);

                    let cost = 0;
                    let worktext = '';

                    if (item.work != null) {
                        item.work.forEach((work) => {
                            cost += work.cost;
                            const workTimestamp = Number(work.date);
                            const workTimeString = new Date(workTimestamp).getTime();
                            worktext += formatDate(workTimeString) + '\t' + work.description + '\t' + work.cost + '\n';
                        });
                    }
                    rowdata.push(cost);
                    rowdata.push(worktext);
                    rowdata.push('icons/clear.png');

                    this.historyGrid.addRow(item.completedId, rowdata, '', '', '', false);
                });
            }
        });
    }

    private buildUI(): void {
        this.historyGrid = this.window.attachGrid();
        this.historyGrid.setHeader('Date, PM, Cost, Work Items,Remove', '', ['text-align:center;', 'text-align:center;', 'text-align:center;', 'text-align:center;', 'text-align:center;']);
        this.historyGrid.setColTypes('ro,ro,ro,txt,img');
        this.historyGrid.setColAlign('left,center,center,center,right');
        this.historyGrid.init();
    }

    private setupEvents(): void {
        this.historyGrid.attachEvent('onRowSelect', (rid, cid) => {
            if (cid == 4) {
                dhtmlx.confirm({
                    type: 'confirm',
                    title: 'Remove Completed PM',
                    text: 'This will remove the completed PM from the history.',
                    ok: 'Remove PM',
                    cancel: 'Cancel.',
                    callback: (result: boolean) => {
                        if (result == true) {
                            this.historyGrid.deleteRow(rid);
                            this.tab.service.deleteCompletedPM(rid);
                        }
                    },
                });
            }
        });
    }
}
